import React, { useEffect, useState, useRef, useCallback } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Drawer,
  Layout,
  Menu,
  Space,
  Row,
  Col,
  Skeleton,
  Button,
  Divider,
  Avatar,
  ConfigProvider,
  List,
  Card,
  Typography,
  Image,
  Modal,
} from "antd";
import Icon, {
  RightOutlined,
  LeftOutlined,
  HomeFilled,
  GoldFilled,
  TrophyFilled,
  GiftFilled,
  SmileFilled,
  SnippetsFilled,
  QuestionCircleFilled,
  ArrowLeftOutlined,
  BookOutlined,
  SecurityScanOutlined,
  MenuOutlined,
  GlobalOutlined,
  CameraFilled,
  ExportOutlined,
  LoadingOutlined,
  DownloadOutlined,
  ReadOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Pagination } from "swiper/modules";
import FileSaver from "file-saver";
import { setCollapsedMenuMobile } from "../../../redux/features/main/localizationSlice";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import moment from "moment";
import "moment/dist/locale/id";

import Books from "../../../assets/images/custom_svgs/Books.jsx";
import IMyLearningJourney from "../../../assets/images/custom_svgs/IMyLearningJourney.jsx";
import Learningpoints from "../../../assets/images/svgs/ic_learningpoints_programdesc.svg";
import IChangePassword from "../../../assets/images/custom_svgs/IChangePassword";
import ILogout from "../../../assets/images/custom_svgs/ILogout";
import defaultImage from "../../../assets/images/png/general/img_thumb_default.png";
import badges_example from "../../../assets/images/svgs/ic_badges_certificate.svg";
import ITeamMonitoring from "../../../assets/images/custom_svgs/ITeamMonitoring.jsx";

import ModalPointHistory from "../../ModalPointHistory";
import ProfilePDF from "../../../components/ProfilePDF";
import ModalDetailJourneyMobileContent from "../../../pages/main/contents/LearningJourney/LearningPages/SubPages/Journey/modal/ModalDetailJourneyMobileContent";
import LogOut from "../../Header/LogOut/LogOut.jsx";
import ChangePassword from "../../Header/ChangePassword/ChangePassword.jsx";
import ModalSuccessCheck from "../../ModalSuccessCheck.jsx";
import ModalChangeLanguage from "../../ModalChangeLanguage";
import ModalContentAdditional from "./ModalDetailModuleMobileContent.jsx";
import { ListSidebar } from "../../../config/constant/sidebar/index.js";

import {
  ColorPrimary,
  colorTextTitleMobile,
  colorBackgroundPhotoProfileUser,
  ColorGrey,
  colorTextDesc,
  textDescProfile,
  ColorSecondary,
  colorButtonLogOut,
  textTitleProfile,
} from "../../../config/constant/color/index";
import styles from "../styles";

import { getAccessToken, getDataPercipio } from "../../../utils.js";

import CustomeLink from "../../CustomeLink";
import useActionsHeader from "../../Header/hooks/useActions.js";
import useActionsProfile from "../../../pages/main/contents/Profile/hooks/useActions.js";
import useActionsCertificate from "../../../pages/main/contents/Profile/elements/certificate/hooks/useActions.js";
import { Loader } from "../../Loader.jsx";

import baseUrl from "../../../config/config.js";

const SidebarMobile = ({ mainState, userData, listJourney }) => {
  const reRenderMenu = useSelector((state) => state.localization.reRenderMenu);
  const collapsedMenuMobile = useSelector(
    (state) => state.localization.collapsedMenuMobile,
  );

  const screens = useBreakpoint();
  const isScallingVersion =
    (window?.innerWidth <= 991 && window.innerWidth >= 768) ||
    window?.innerWidth === 581;
  const isMobileVersion = screens.xs || isScallingVersion;

  const [isOpenPointHistory, _setIsOpenPointHistory] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [disableExport, setDisableExport] = useState(true);
  // const [detailUser, setDetailUser] = useState([]);
  const [loadingDetail, setLoadingDetail] = useState(true);
  const [openModalLogout, setModalLogout] = useState(false);
  const [openModalPassword, setModalPassword] = useState(false);
  const [modalSuccessPassword, setModalSuccessPassword] = useState(false);
  const [isOpenModalChangeLanguage, setIsOpenModalChangeLanguage] =
    useState(false);
  const [showListAchievements, setShowListAchievements] = useState(false);

  const [modalCertificate, setModalCertificate] = useState(false);
  const [listAchievements, setListAchievements] = useState([]);
  const [listAchievementsLoading, setListAchievementsLoading] = useState(false);
  const [btnPrev, setBtnPrev] = useState();
  const [btnNext, setBtnNext] = useState();
  const loading = false;
  const [imageItem, setImageItem] = useState();
  const [imgBadgesPopup, setImgBadgesPopup] = useState();
  const [dateBadgesPopup, setDateBadgesPopup] = useState();
  const [badgesNamePopup, setBadgesNamePopup] = useState();
  const [fromModuleBadgesPopup, setFromModuleBadgesPopup] = useState();
  const [ItemCompletedProgram, setItemCompletedProgram] = useState([]);
  const [itemAdditionalLearning, setItemAdditionalLearning] = useState([]);

  const [isModalOpenBadges, setIsModalOpenBadges] = useState(false);
  const [isModalProgram, setIsModalProgram] = useState(false);
  const [isModalAdditionalLearning, setIsModalAdditionalLearning] =
    useState(false);

  const [resultFilterMenu, setResultFilterMenu] = useState([]);
  const [titleAchievements, setTitleAchievements] = useState("");
  const [emptyWordingAchievements, setEmptyWordingAchievements] = useState("");
  const [titleAchievementsWithLength, setTitleAchievementsWithLength] =
    useState("");

  const fileInputRef = useRef(null);
  const sliderRef = useRef(null);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const selectedKey = useLocation().pathname;
  const localeDate = i18n.language === "en" ? "en" : "id";

  // Percipio
  const percData = getDataPercipio();
  const loginUrl = percData.url_login || "#";

  const setIsOpenPointHistory = (v) => {
    _setIsOpenPointHistory(v);
  };

  const {
    handleFetchPointHistory,
    pointHistoryData,
    setPointHistoryData,
    dateModuleConvert,
    handleLogOut,
  } = useActionsHeader({ setIsOpenPointHistory });

  const { fetchListCertifPopup, listCertifPopup } =
    useActionsCertificate(setModalCertificate);

  const {
    detailUser,
    journey: completeProgram,
    loadingJourney: loadingCompleteProgram,
    achievements: badges,
    certificate,
    handleChangePicture,
    additional,
    fetchDetailProfile,
    fetchAdditional,
    loadingAchievement: loadingBadges,
    loadingCertif: loadingCertif,
    loadingDetail: loadingDetailProfile,
    loadingAdditional: loadingAdditional,
    fetchListCompletedJourney,
    fetchListCertificates,
    fetchListAchievements,
  } = useActionsProfile(loading, userData, listJourney, mainState);

  useEffect(() => {
    dispatch(setCollapsedMenuMobile(false));
    filterMenu(userData);
    if (userData.userId) {
      fetchAdditional(userData.userId);
    }
  }, [userData, reRenderMenu]);

  const handleMenuClick = (e) => {
    switch (e.key) {
      case "language":
        setIsOpenModalChangeLanguage(true);
        break;
      case "change-password":
        setModalPassword(true);
        break;
      case "logout":
        setModalLogout(true);
        break;
      default:
        dispatch(setCollapsedMenuMobile(false));
        break;
    }
  };

  const MenuItem = [
    {
      key: "group-1",
      className: "group-setting",
      type: "group",
      children: [
        {
          key: "home",
          icon: <HomeFilled />,
          name: "btn-home-menu",
          label: (
            <div>
              <CustomeLink to="/home" mainState={mainState}>
                {t("main.sidebar.home")}
              </CustomeLink>
            </div>
          ),
        },
        {
          key: "divider-1",
          type: "divider",
        },
        {
          key: "learningJourney",
          icon: <Icon component={IMyLearningJourney} />,
          name: "btn-my-learning-journey-menu",
          label: (
            <div>
              <CustomeLink to="/my-learning-journey" mainState={mainState}>
                {t("main.sidebar.my_learning_journey")}
              </CustomeLink>
            </div>
          ),
        },
        {
          key: "divider-2",
          type: "divider",
        },
        {
          key: "contentLibrary",
          icon: <Icon component={Books} />,
          name: "btn-content-library-menu",
          label: (
            <div>
              <CustomeLink to="/content-library" mainState={mainState}>
                {t("main.sidebar.content_library")}
              </CustomeLink>
            </div>
          ),
        },
      ],
    },
    {
      key: "group-2",
      className: "group-setting",
      type: "group",
      children: [
        {
          key: "leaderboards",
          icon: <TrophyFilled />,
          name: "btn-leaderboards-menu",
          label: (
            <div>
              <CustomeLink to="/leaderboards" mainState={mainState}>
                {t("main.sidebar.leaderboards")}
              </CustomeLink>
            </div>
          ),
        },
        {
          key: "divider-5",
          type: "divider",
        },
        {
          key: "rewards",
          icon: <GiftFilled />,
          name: "btn-rewards-menu",
          label: (
            <div>
              <CustomeLink to="/rewards" mainState={mainState}>
                {t("main.sidebar.rewards")}
              </CustomeLink>
            </div>
          ),
        },
      ],
    },
    {
      key: "group-3",
      type: "group",
      className: "group-setting",
      children: [
        {
          key: "teamMonitoring",
          icon: <Icon component={ITeamMonitoring} style={{ width: 18 }} />,
          name: "btn-team-monitoring-menu",
          label: (
            <div>
              <CustomeLink to="/team-monitoring" mainState={mainState}>
                {t("main.sidebar.team_monitoring")}
              </CustomeLink>
            </div>
          ),
        },
        {
          key: "divider-6",
          type: "divider",
        },
        {
          key: "reviews",
          icon: <SnippetsFilled />,
          name: "btn-reviews-menu",
          label: (
            <div>
              <CustomeLink to="/reviews" mainState={mainState}>
                {t("main.sidebar.reviews")}
              </CustomeLink>
            </div>
          ),
        },
        {
          key: "skillsoft",
          icon: <ReadOutlined />,
          name: "btn-skillsoft-menu",
          label: (
            <div>
              <a
                href={loginUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Skillsoft Percipio
              </a>
            </div>
          ),
        },
      ],
    },
    {
      key: "group-4",
      type: "group",
      className: "group-setting",
      children: [
        {
          key: "help",
          icon: <QuestionCircleFilled />,
          name: "btn-help-menu",
          label: (
            <div>
              <CustomeLink to="/help/faq" mainState={mainState}>
                {t("main.sidebar.help_center")}
              </CustomeLink>
            </div>
          ),
        },
        {
          key: "divider-7",
          type: "divider",
        },
        {
          key: "language",
          icon: <Icon component={GlobalOutlined} />,
          name: "btn-change-language-menu",
          label: <div>{t("main.header.dropdown_profile.change_language")}</div>,
        },
        // {
        //   key: "divider-8",
        //   type: "divider",
        // },
        // {
        //   key: "change-password",
        //   icon: <Icon component={IChangePassword} style={{ width: "18px" }} />,
        //   name: "btn-change-password-menu",
        //   label: <div>Change Password</div>,
        // },
      ],
    },
    // {
    //   key: "group-5",
    //   type: "group",
    //   className: "group-setting",
    //   children: [
    //     {
    //       key: "logout",
    //       icon: <Icon component={ILogout} style={{ width: "18px" }} />,
    //       name: "btn-logout-user-profile",
    //       label: <div>Log out</div>,
    //     },
    //   ],
    // },
  ];

  // const filterMenu = (data) => {
  //   const filter = MenuItem.filter(function (obj) {
  //     if (data.is_supervisor === 1) {
  //       return obj;
  //     } else {
  //       return (
  //         obj.key !== "teamMonitoring" &&
  //         obj.key !== "reviews" &&
  //         obj.key !== "divider-2"
  //       );
  //     }
  //   });

  //   setResultFilterMenu(filter);
  // };

  // const filterMenu = (data) => {
  //     // Prepare whitelist keys from ListSidebar for whitelabeling validation
  //     const listSidebarKey = ListSidebar.map((item) => item.key.toLowerCase());
  
  //     // Get Percipio configuration from localStorage
  //     const percData = getDataPercipio();
  //     const isShowPercipio = percData.is_show_percipio == "true";
  
  
  //     const filter = MenuItem.map((group) => {
  //       if (group.key !== "group-3") {
  //         return group;
  //       }

  //       const children = group.children.filter((item) => {
  //         // Supervisor
  //         if (data.is_supervisor === 1) {
  //           if (isShowPercipio) {
  //             return true;
  //           }

  //           return item.key !== "skillsoft";
  //         }

  //         // Non Supervisor
  //         if (isShowPercipio) {
  //           return item.key === "skillsoft";
  //         }

  //         return false;
  //       });

  //       return {
  //         ...group,
  //         children,
  //       };
  //     });
  //     console.log(filter)
  //     setResultFilterMenu(filter);
  
  //     // setResultFilterMenu(filter);
  //   };

    const filterMenu = (data) => {
      
      // Prepare whitelist keys from ListSidebar for whitelabeling validation
      const listSidebarKey = ListSidebar.map((item) => item.key.toLowerCase());

      // Get Percipio configuration from localStorage
      const percData = getDataPercipio();
      const isShowPercipio = percData.is_show_percipio === "true";

      const filter = MenuItem.map((group) => {
        // Hanya filter group-3
        if (group.key !== "group-3") {
          return group;
        }

        let children = [];

        if (data.is_supervisor === 1) {
          // Supervisor

          if (isShowPercipio) {
            // Return semua menu
            children = group.children;
          } else {
            // Hilangkan skillsoft saja
            children = group.children.filter(
              (item) => item.key !== "skillsoft"
            );
          }
        } else {
          // Non Supervisor

          if (isShowPercipio) {
            // Hanya tampilkan skillsoft
            children = group.children.filter(
              (item) => item.key === "skillsoft"
            );
          } else {
            // Tidak tampilkan apa pun
            children = [];
          }
        }

        return {
          ...group,
          children,
        };
      });

      setResultFilterMenu(filter);
    };

  const highlight = () => {
    switch (true) {
      case selectedKey === "/" ||
        selectedKey.indexOf("/home") > -1 ||
        selectedKey.indexOf("/main") > -1:
        return ["home"];
      case selectedKey.indexOf("/my-learning-journey") > -1:
        return ["learningJourney"];
      case selectedKey.indexOf("/content-library") > -1:
        return ["contentLibrary"];
      case selectedKey.indexOf("/achievements") > -1:
        return ["achievements"];
      case selectedKey.indexOf("/leaderboards") > -1:
        return ["leaderboards"];
      case selectedKey.indexOf("/rewards") > -1:
        return ["rewards"];
      case selectedKey.indexOf("/team-monitoring") > -1:
        return ["teamMonitoring"];
      case selectedKey.indexOf("/reviews") > -1:
        return ["reviews"];
      case selectedKey.indexOf("/help") > -1:
        return ["help"];
      case selectedKey.indexOf("/scan") > -1:
        return ["scan"];
      default:
        return null;
    }
  };

  const handlePointClicked = () => handleFetchPointHistory();

  const numberWithDot = (x) => {
    if (x !== null && x !== undefined) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    handleChangePicture(selectedFile);
  };

  const handleCapture = () => {
    setLoadingExport(true);
    const content = document.getElementById("export-content");
    if (content) {
      html2canvas(content, {
        dpi: 300,
        scale: 5,
        useCORS: true,
      })
        .then((canvas) => {
          //code for auto second page
          const imgWidth = 210;
          const pageHeight = 297;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          let position = 0;
          heightLeft -= pageHeight;
          const doc = new jsPDF("p", "mm", [297, 210]);
          doc.addImage(
            canvas,
            "PNG",
            0,
            position,
            imgWidth,
            imgHeight,
            "",
            "FAST",
          );
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(
              canvas,
              "PNG",
              0,
              position,
              imgWidth,
              imgHeight,
              "",
              "FAST",
            );
            heightLeft -= pageHeight;
          }
          doc.save("profile.pdf");
        })
        .then(() => {
          setLoadingExport(false);
        });
    }
  };

  const handleExportProfile = () => {
    setLoadingExport(true);
    let urlExportProfile = baseUrl + `/profile/export?token=${getAccessToken()}&lang=${localeDate}`;

    FileSaver.saveAs(urlExportProfile);
    setLoadingExport(false);
  }

  useEffect(() => {
    if (userData) {
      fetchDetailProfile(userData);
    }
  }, [userData]);

  const [listAchievementsAdditional, setListAchievementsAdditional] = useState(
    [],
  );
  const [listAchievementsBadges, setListAchievementsBadges] = useState([]);
  const [listAchievementsCompleteProgram, setListAchievementsCompleteProgram] =
    useState([]);
  const [listAchievementsCertificates, setListAchievementsCertificates] =
    useState([]);
  const [lengthAchievements, setLengthAchievements] = useState(0);

  const checkCertifValid = (time) => {
    // null / undefined / empty string dianggap valid
    if (time == null || time === "") return true;

    // pecah "2026-05-02 00:00:00"
    const [datePart, timePart] = time.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    const inputDate = new Date(year, month - 1, day, hour, minute, second);
    const now = new Date();

    // true = masih valid
    // false = expired
    return inputDate >= now;
  };

  // Hapus: const [listAchievements, setListAchievements] = useState([]);

  // Fungsi untuk memilih listAchievements sesuai judul/tab
  const getCurrentListAchievements = () => {
    // console.log("masuk getCurrentListAchievements", titleAchievements);
    if (titleAchievements === t("feature.feature_tm.additional_learning")) {
      return listAchievementsAdditional;
    }
    if (
      titleAchievements ===
      t("feature.feature_profile.main_content.completed_program")
    ) {
      return listAchievementsCompleteProgram;
    }
    if (
      titleAchievements ===
      t("feature.feature_profile.main_content.certificates")
    ) {
      return listAchievementsCertificates;
    }
    if (
      titleAchievements === t("feature.feature_profile.main_content.badges")
    ) {
      return listAchievementsBadges;
    }
    return [];
  };

  useEffect(() => {
    if (titleAchievements) {
      const title = titleAchievements.split("(")[0].trim();
      setTitleAchievements(title);
      if (title === t("feature.feature_tm.additional_learning")) {
        setEmptyWordingAchievements(
          t("feature.feature_tm.not_completed_any_module"),
        );
        fetchAdditional(userData.userId);
      } else if (
        title === t("feature.feature_profile.main_content.completed_program")
      ) {
        setEmptyWordingAchievements(
          t("feature.feature_tm.not_completed_any_program"),
        );
        fetchListCompletedJourney();
      } else if (
        title === t("feature.feature_profile.main_content.certificates")
      ) {
        setEmptyWordingAchievements(
          t("feature.feature_tm.no_certificates_acquired"),
        );
        fetchListCertificates();
      } else if (title === t("feature.feature_profile.main_content.badges")) {
        setEmptyWordingAchievements(t("feature.feature_tm.no_badges_acquired"));
        fetchListAchievements();
      } else {
        setEmptyWordingAchievements("");
      }
    } else {
      setTitleAchievements("titlenya ga dapet");
    }

    return () => {
      setTitleAchievements("");
    };
  }, [titleAchievements]);

  function handleAchievementsClicked(e) {
    e.preventDefault();
    let title = "";
    if (e && e.currentTarget && e.currentTarget.innerText) {
      // title = e.currentTarget.innerText.replace(/\s?\(.*?\)/g, "");
      title = e.currentTarget.innerText;
    }

    setTitleAchievementsWithLength(title);
    setTitleAchievements(title);
    setShowListAchievements(true);
    setListAchievementsLoading(true);

    // setTimeout(() => {
    //   setListAchievementsLoading(false);
    // }, 1000);
  }

  // console.log("collapsedMenuMobile", collapsedMenuMobile);

  // Clear listAchievements ketika modal ditutup
  useEffect(() => {
    if (!showListAchievements) {
      setListAchievementsAdditional([]);
      setListAchievementsBadges([]);
      setListAchievementsCompleteProgram([]);
      setListAchievementsCertificates([]);
      setTitleAchievements("");
      setEmptyWordingAchievements("");
    }
  }, [showListAchievements]);

  // Sync data achievements sesuai tab/modal
  useEffect(() => {
    if (
      showListAchievements &&
      titleAchievements === t("feature.feature_tm.additional_learning")
    ) {
      setListAchievementsAdditional((prev) => {
        if (JSON.stringify(prev) !== JSON.stringify(additional)) {
          return additional;
        }
        return prev;
      });
      setListAchievementsLoading(false);
    }
  }, [additional]);

  useEffect(() => {
    if (
      showListAchievements &&
      titleAchievements ===
      t("feature.feature_profile.main_content.certificates")
    ) {
      setListAchievementsCertificates((prev) => {
        if (JSON.stringify(prev) !== JSON.stringify(certificate)) {
          return certificate;
        }
        return prev;
      });
      setListAchievementsLoading(false);
    }
  }, [certificate]);

  useEffect(() => {
    if (
      showListAchievements &&
      titleAchievements ===
      t("feature.feature_profile.main_content.completed_program")
    ) {
      setListAchievementsCompleteProgram((prev) => {
        if (JSON.stringify(prev) !== JSON.stringify(completeProgram)) {
          return completeProgram;
        }
        return prev;
      });
      setListAchievementsLoading(false);
    }
  }, [completeProgram]);

  useEffect(() => {
    if (
      showListAchievements &&
      titleAchievements === t("feature.feature_profile.main_content.badges")
    ) {
      setListAchievementsBadges((prev) => {
        if (JSON.stringify(prev) !== JSON.stringify(badges)) {
          return badges;
        }
        return prev;
      });
      setListAchievementsLoading(false);
    }
  }, [badges]);

  useEffect(() => {
    if (collapsedMenuMobile) {
      if (userData.userId) {
        fetchAdditional(userData.userId);
        fetchListCompletedJourney();
        fetchListCertificates();
        fetchListAchievements();
      }
    }
  }, [collapsedMenuMobile]);

  const skeletonCriteriaAchievements = (
    <Skeleton.Input
      active
      size="default"
      style={{ borderRadius: "20px", width: "100%" }}
      className="skeleton-input-achievements"
    />
  );

  const handleLogOutClick = () => {
    setModalLogout(!openModalLogout);
    handleLogOut();
  };

  const getPropData = (item) => {
    switch (titleAchievements) {
      // case "Additional Learning":
      case `${t("feature.feature_tm.additional_learning")}`:
        return {
          thumbnail: item?.thumbnail,
          title: item?.module_name,
          labelDate: t("feature.feature_tm.completed_on"),
          date: item?.completed_date,
          module: item?.journey_name,
        };
      // case "Completed Program":
      case `${t("feature.feature_profile.main_content.completed_program")}`:
        return {
          thumbnail: item?.thumbnail,
          title: item?.name,
          labelDate: t(
            "feature.feature_profile.sec_completed_program.completed_on",
          ),
          date: item?.completed_date,
          module: "",
        };
      // case "Certificates":
      case `${t("feature.feature_profile.main_content.certificates")}`:
        return {
          thumbnail: item?.file_name,
          title: item?.name_certif,
          labelDate: t("feature.feature_profile.sec_certi.earned_on"),
          date: item?.recived,
          module: item.journey_name,
          valid_until: item.valid_until,
        };
      // case "Badges":
      case `${t("feature.feature_profile.main_content.badges")}`:
        return {
          thumbnail: item?.logo,
          title: item?.name,
          labelDate: t("feature.feature_profile.sec_badges.earned_on_badges"),
          date: item?.created_at,
          module: item.module,
        };
      default:
        return undefined;
    }
  };

  const handleOnClickCard = (item) => {
    if (
      titleAchievements ===
      `${t("feature.feature_profile.main_content.certificates")}`
    ) {
      fetchListCertifPopup(item?.journey_id, item?.course_id, item?.module_id);
    }
    if (
      titleAchievements ===
      `${t("feature.feature_profile.main_content.badges")}`
    ) {
      setImgBadgesPopup(item.logo);
      setDateBadgesPopup(
        moment(item.created_at).locale(localeDate).format("DD MMM YYYY"),
      );
      setFromModuleBadgesPopup(item.module);
      setBadgesNamePopup(item.name);
      setIsModalOpenBadges(true);
    }
    if (
      titleAchievements ===
      `${t("feature.feature_profile.main_content.completed_program")}`
    ) {
      setItemCompletedProgram(item);
      setIsModalProgram(!isModalProgram);
    }
    if (
      titleAchievements === `${t("feature.feature_tm.additional_learning")}`
    ) {
      setItemAdditionalLearning(item);
      setIsModalAdditionalLearning(!isModalAdditionalLearning);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setBtnPrev(document.querySelector("#id-btn-prev-certif-profile"));
      setBtnNext(document.querySelector("#id-btn-next-certif-profile"));
      setImageItem([...listCertifPopup]);
    }, 500);
  }, [modalCertificate]);

  const onSwiperMove = (e) => {
    if (btnPrev !== null && btnNext !== null) {
      if (e.activeIndex === 0) {
        btnPrev.classList.add("hidden");
      } else {
        btnPrev.classList.remove("hidden");
      }

      if (e.activeIndex === listCertifPopup.length - 1) {
        btnNext.classList.add("hidden");
      } else {
        btnNext.classList.remove("hidden");
      }

      setImageItem([...listCertifPopup]);
    }
  };

  const downloadImageCertif = () => {
    let url = baseUrl + "/cots/certificate/download?link_file=";

    if (imageItem.length > 1) {
      const combineString = imageItem.join("~");
      FileSaver.saveAs(url + combineString);
    } else {
      FileSaver.saveAs(url + imageItem[0]);
    }
  };

  return (
    <ConfigProvider
      theme={{
        token: styles.themeToken,
      }}
    >
      <Drawer
        open={collapsedMenuMobile}
        placement="right"
        title={"Menu Mobile"}
        closable={false}
        className="sidebar-mobile"
        onClose={() => dispatch(setCollapsedMenuMobile(false))}
        width={"100%"}
        style={{
          maxWidth: "585px",
          top: "50%",
          left: "50%",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          position: "absolute",
        }}
        destroyOnClose={true}
      >
        <Row style={styles.headerMobile} justify={"space-between"}>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Col
              span={8}
              style={{
                position: "relative",
              }}
            >
              <div
                className="btn-back-mobile"
                style={{
                  position: "fixed",
                  top: "15px",
                  left: "20px",
                  cursor: "pointer",
                  borderRadius: "50%",
                  width: "40px",
                  height: "38.27px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.18)",
                  zIndex: 20,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(setCollapsedMenuMobile(false));
                }}
              >
                <ArrowLeftOutlined
                  style={{
                    color: colorTextTitleMobile,
                    width: "15px",
                    height: "15px",
                  }}
                />
              </div>
            </Col>
            <Col span={24} style={{ flex: 1 }}>
              <Row justify={"end"} style={{ gap: "24px" }}>
                <Col
                  className="learning-point-wrapper"
                  style={styles.colRightWrapperMobile}
                  onClick={() => handlePointClicked()}
                >
                  <img
                    src={Learningpoints}
                    style={styles.imageLearningPoint}
                    alt="Learning Points Mobile"
                  />
                  <div style={styles.learningPointSkelWrapperMobile}>
                    <span
                      style={styles.pointsMobile}
                      className="learning-points"
                    >
                      {userData?.learningPoints === undefined ? (
                        <>
                          <Skeleton.Input active />
                        </>
                      ) : (
                        numberWithDot(userData?.learningPoints)
                      )}
                    </span>
                    <span style={styles.textLearningPointsMobile}>
                      {t("main.header.learning_points")}
                    </span>
                  </div>
                </Col>
                <Col style={{ fontSize: "20px", height: "26px" }}>
                  <div
                    style={{
                      background: "transparent",
                      cursor: "pointer",
                      color: `${disableExport ? ColorGrey : ColorPrimary}`,
                      pointerEvents:
                        disableExport || loadingExport ? "none" : "unset",
                      id: "btn-export-profile-user-profile",
                    }}
                    onClick={handleExportProfile}
                  >
                    {loadingExport ? (
                      <LoadingOutlined
                        style={{ width: "20px", height: "20px" }}
                      />
                    ) : (
                      <ExportOutlined
                        style={{ width: "20px", height: "20px" }}
                      />
                    )}
                    {/* <span
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        lineHeight: "100%",
                      }}
                    >
                      {t("feature.feature_profile.header.export_profile")}
                    </span> */}
                  </div>
                </Col>
              </Row>
            </Col>
          </div>

          <Col span={24} style={{ marginTop: "24px" }}>
            <Row
              style={{ display: "flex", gap: "20px", flexWrap: "nowrap" }}
              align={"middle"}
            >
              <Col onClick={handleButtonClick}>
                {userData.userName === undefined ? (
                  <>
                    <Skeleton.Avatar active size={78} />
                  </>
                ) : (
                  <>
                    <Avatar
                      size={78}
                      src={userData.picture}
                      style={{
                        backgroundColor: colorBackgroundPhotoProfileUser,
                        fontSize: "32px",
                        fontWeight: "500",
                        cursor: "pointer",
                        border: "none",
                      }}
                    >
                      {userData.firstname &&
                        Array.from(userData.firstname)[0].toUpperCase()}
                    </Avatar>
                  </>
                )}

                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  id="id-upload-user-profile"
                  accept="image/*"
                />
                <Button
                  style={styles.buttonCamera}
                  icon={<CameraFilled style={styles.iconCamera} />}
                  id="btn-upload-user-profile"
                />
              </Col>
              <Col
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <div style={styles.userFullname}>{userData.userName}</div>
                <div style={styles.valuePosition}>
                  {userData.userPosition === "" ? "-" : userData.userPosition}
                </div>
              </Col>
            </Row>

            <Row
              // gutter={[16, 8]}
              wrap
              style={{
                display: "flex",
                marginTop: "14px",
                justifyContent: "left",
                alignItems: "center",
                width: "100%",
                columnGap: "32px",
                rowGap: "18px",
              }}
              align={"middle"}
            >
              <Col
                xs={12}
                style={{
                  width: "100%",
                  maxWidth: "fit-content",
                }}
              >
                <span style={styles.labelProfile}>
                  {t("feature.feature_profile.header.username")}
                </span>
                <div style={styles.labelValue} contentEditable={false}>
                  {
                    loadingDetailProfile ? (
                      <Skeleton.Input active size="small" />
                    ) : detailUser?.email ? (
                      detailUser.email
                    ) : (
                      "-"
                    )
                  }
                </div>
              </Col>

              <Col
                xs={12}
                style={{
                  width: "100%",
                  maxWidth: "fit-content",
                }}
              >
                <span style={styles.labelProfile}>
                  {t("feature.feature_profile.header.registered_on")}
                </span>
                <div style={styles.labelValue}>
                  {
                    loadingDetailProfile ? (
                      <Skeleton.Input active size="small" />
                    ) : detailUser?.created_at ? (
                      moment(detailUser.created_at).locale(localeDate).format("DD MMMM YYYY")
                    ) : (
                      "-" // atau kosong ""
                    )
                  }
                </div>
              </Col>
            </Row>

            <Row
              align={"middle"}
              justify={"space-between"}
              style={{ marginTop: "18px" }}
            >
              <div>
                <Row gutter={[6, 6]}>
                  <Col span={12}>
                    {loadingCertif ? (
                      skeletonCriteriaAchievements
                    ) : (
                      <Button
                        style={styles.chipCertificate}
                        ghost
                        onClick={(e) => handleAchievementsClicked(e)}
                      >
                        {t("feature.feature_profile.main_content.certificates")}{" "}
                        ({certificate.length})
                      </Button>
                    )}
                  </Col>
                  <Col span={12}>
                    {loadingBadges ? (
                      skeletonCriteriaAchievements
                    ) : (
                      <Button
                        style={styles.chipCertificate}
                        ghost
                        onClick={(e) => handleAchievementsClicked(e)}
                      >
                        {t("feature.feature_profile.main_content.badges")} (
                        {badges.length})
                      </Button>
                    )}
                  </Col>
                  <Col span={12}>
                    {loadingCompleteProgram ? (
                      skeletonCriteriaAchievements
                    ) : (
                      <Button
                        style={styles.chipCertificate}
                        ghost
                        onClick={(e) => handleAchievementsClicked(e)}
                      >
                        {t(
                          "feature.feature_profile.main_content.completed_program",
                        )}{" "}
                        ({completeProgram.length})
                      </Button>
                    )}
                  </Col>
                  <Col span={12}>
                    {loadingAdditional ? (
                      skeletonCriteriaAchievements
                    ) : (
                      <Button
                        style={styles.chipCertificate}
                        ghost
                        onClick={(e) => handleAchievementsClicked(e)}
                      >
                        {t("feature.feature_tm.additional_learning")} (
                        {additional.length})
                      </Button>
                    )}
                  </Col>
                </Row>
              </div>
            </Row>

            {/* <Row
              align={"middle"}
              justify={"center"}
              style={{ marginTop: "20px" }}
            >
              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "transparent",
                    cursor: "pointer",
                    gap: "4px",
                    color: `${
                      disableExport || loadingExport ? ColorGrey : ColorPrimary
                    }`,
                    pointerEvents:
                      disableExport || loadingExport ? "none" : "unset",
                    id: "btn-export-profile-user-profile",
                  }}
                  onClick={handleCapture}
                >
                  {loadingExport ? (
                    <LoadingOutlined
                      style={{ width: "16px", height: "16px" }}
                    />
                  ) : (
                    <ExportOutlined style={{ width: "16px", height: "16px" }} />
                  )}
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      lineHeight: "100%",
                    }}
                  >
                    {t("feature.feature_profile.header.export_profile")}
                  </span>
                </div>
              </Col>
            </Row> */}
          </Col>
        </Row>
        <Menu
          selectedKeys={highlight()}
          mode="inline"
          inlineIndent={23}
          defaultSelectedKeys={["home"]}
          items={resultFilterMenu}
          style={styles.menuWrapperMobile}
          onClick={handleMenuClick}
          className="menu-sidebar-mobile"
        />

        <div
          style={{
            width: "1217px",
            maxWidth: "1217px",
            lineHeight: "normal",
            textAlign: "left",
            overflow: "hidden",
            height: 0,
          }}
        >
          <div id="export-content">
            <ProfilePDF
              disableExport={disableExport}
              setDisableExport={setDisableExport}
              userData={userData}
              detailUser={detailUser}
              achievements={badges}
              certificate={certificate}
              journey={completeProgram}
              additional={additional}
            />
          </div>
        </div>
      </Drawer>

      <ModalPointHistory
        isOpenPointHistory={isOpenPointHistory}
        setIsOpenPointHistory={setIsOpenPointHistory}
        pointHistoryData={pointHistoryData}
        setPointHistoryData={setPointHistoryData}
        points={userData?.learningPoints}
        dateModuleConvert={dateModuleConvert}
        isMobileVersion={isMobileVersion}
      />

      <LogOut
        openModalLogout={openModalLogout}
        setModalLogout={setModalLogout}
        handleLogOutClick={handleLogOutClick}
      />

      <ChangePassword
        openModalPassword={openModalPassword}
        setModalPassword={setModalPassword}
        setModalSuccessPassword={setModalSuccessPassword}
      />

      <ModalSuccessCheck
        mainState={undefined}
        confirmRating={false}
        textTitle={t(
          "feature.home.pop_up_change_password.password_successfully_changed",
        )}
        textDesc={t(
          "feature.home.pop_up_change_password.please_use_new_password_next_login",
        )}
        modalSuccess={modalSuccessPassword}
        setModalSuccess={setModalSuccessPassword}
      />

      <ModalChangeLanguage
        ti18n={t}
        i18n={i18n}
        setIsOpenModalChangeLanguage={setIsOpenModalChangeLanguage}
        isOpenModalChangeLanguage={isOpenModalChangeLanguage}
      />

      <Modal
        className="list-achievements"
        open={showListAchievements}
        mask={false}
        maskClosable={false}
        transitionName=""
        style={{
          maxWidth: "585px",
          borderRadius: "0px",
          textAlign: "center",
          top: "50%",
          left: "50%",
          margin: "0",
          transform: "translate(-50%, -50%)",
          position: "absolute",
          height: "100%",
        }}
        width={"100%"}
        keyboard
        centered
        destroyOnClose={true}
        footer={null}
        closeIcon={null}
        title={
          <div
            style={{
              height: "57px",
              display: "flex",
              alignItems: "center",
              gap: 12,
              flex: 0,
              padding: "16px 24px",
              fontSize: "16px",
              lineHeight: 1.5,
              borderBottom: "1px solid rgba(5, 5, 5, 0.06)",
              position: "fixed",
              top: 0,
              left: 0,
              zIndex: 1001,
              borderRadius: 0,
              width: "100%",
              backgroundColor: "#FFFFFF",
            }}
          >
            <ArrowLeftOutlined
              style={{ color: "#212121" }}
              onClick={(e) => {
                e.preventDefault();
                setShowListAchievements(false);
              }}
            />
            <div
              style={{
                fontSize: 16,
                fontWeight: 500,
                color: "#212121",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "auto",
                maxWidth: "250px",
              }}
            >
              <span>
                {/* {titleAchievements} ({lengthAchievements}) */}
                {titleAchievementsWithLength}
              </span>
            </div>
          </div>
        }
      >
        {loadingCertif ||
          loadingAdditional ||
          loadingBadges ||
          loadingCompleteProgram ||
          listAchievementsLoading ? (
          <Loader />
        ) : (
          <List
            itemLayout="horizontal"
            dataSource={getCurrentListAchievements()}
            locale={{
              emptyText: emptyWordingAchievements,
            }}
            renderItem={(item) => (
              <Card
                style={{
                  marginBottom: 18,
                  borderRadius: 12,
                  height: "100%",
                  boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.06)",
                  border: "1px solid rgba(220, 229, 235, 1)",
                }}
                bodyStyle={{ padding: 0 }}
                onClick={() => handleOnClickCard(item)}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  {!getPropData(item)?.thumbnail ? (
                    <div
                      className="skeleton-image-achievements"
                      style={{ width: 127, height: 108, borderRadius: "12px" }}
                    >
                      <Skeleton.Image active />
                    </div>
                  ) : (
                    <Image
                      preview={false}
                      src={getPropData(item)?.thumbnail}
                      width={127}
                      height={108}
                      style={{
                        borderRadius: "12px",
                        objectFit:
                          titleAchievements ===
                            t("feature.feature_profile.main_content.badges")
                            ? "contain"
                            : "cover",
                        padding:
                          titleAchievements ===
                            t("feature.feature_profile.main_content.badges")
                            ? "12px"
                            : "0",
                        filter: checkCertifValid(item.valid_until) ? "none" : "grayscale(100%)"
                      }}
                      fallback={
                        titleAchievements ===
                          t("feature.feature_profile.main_content.badges")
                          ? badges_example
                          : defaultImage
                      }
                      alt={`${titleAchievements} Mobile Image`}
                    />
                  )}
                  <div
                    style={{
                      flex: 1,
                      paddingRight: "12px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                      textAlign: "left",
                      gap:
                        titleAchievements === "Completed Program"
                          ? "3vh"
                          : "2vh",
                    }}
                  >
                    <div
                      style={{
                        height: "32px",
                        paddingTop: "6px",
                      }}
                    >
                      <div
                        className="break-dots-second-line"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontSize: "14px",
                          lineHeight: "normal",
                          fontWeight: "500",
                          color: colorTextTitleMobile,
                        }}
                      >
                        {getPropData(item)?.title}
                      </div>
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <div
                        style={{
                          color: textDescProfile,
                          fontSize: "12px",
                          fontWeight: "400",
                        }}
                      >
                        {getPropData(item)?.labelDate}{" "}
                        <span
                          style={{
                            fontWeight: "500",
                            color: colorTextTitleMobile,
                          }}
                        >
                          {moment(getPropData(item)?.date)
                            .locale(localeDate)
                            .format("DD MMM YYYY")}
                        </span>
                      </div>
                      <div
                        style={{
                          color: textDescProfile,
                          fontSize: "12px",
                          fontWeight: "400",
                          display: item.valid_until === undefined ? "none" : "block"
                        }}
                      >
                        {t('feature.feature_profile.sec_certi.valid_until')}&nbsp;
                        <span
                          style={{
                            fontWeight: "500",
                            color: colorTextTitleMobile,
                          }}
                        >
                          {item.valid_until == null ? "-" : 
                            moment(getPropData(item)?.valid_until)
                              .locale(localeDate)
                              .format("DD MMM YYYY")
                          }
                        </span>
                      </div>
                      {getPropData(item)?.module && (
                        <div
                          className="break-dots-first-line"
                          style={{
                            color: textDescProfile,
                            fontSize: "12px",
                            fontWeight: "400",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            wordBreak: "break-all",
                          }}
                        >
                          {t(
                            "feature.feature_profile.sec_popup_completed_program.program",
                          )}{" "}
                          <span
                            style={{
                              fontWeight: "500",
                              color: colorTextTitleMobile,
                            }}
                          >
                            {getPropData(item)?.module}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Card>
            )}
          />
        )}
      </Modal>

      <Modal
        className="modal-certificate-mobile"
        open={modalCertificate}
        maskClosable={false}
        transitionName="ant-fade"
        style={{ maxWidth: "585px", borderRadius: "16px", textAlign: "center" }}
        width={
          isMobileVersion
            ? isScallingVersion
              ? `${585 * 0.9}px`
              : "90%"
            : "90%"
        }
        onCancel={() => {
          setModalCertificate(false);
        }}
        keyboard
        centered
        destroyOnClose={true}
        footer={null}
        closeIcon={null}
      >
        <div style={{ padding: "20px" }}>
          <div>
            {listCertifPopup.length > 0 ? (
              <Swiper
                ref={sliderRef}
                slidesPerView={1}
                spaceBetween={20}
                modules={[Navigation, Pagination]}
                onSlideChange={(e) => onSwiperMove(e)}
                pagination={{
                  clickable: true,
                }}
              >
                {listCertifPopup.map((item, index) => (
                  <SwiperSlide key={index} data-id={index}>
                    <Image
                      width={"100%"}
                      height={"100%"}
                      src={item}
                      fallback={defaultImage}
                      alt="Certificate Mobile"
                      preview={false}
                      style={{ borderRadius: "12px", objectFit: "contain" }}
                      id="canvas-image"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <Image
                width={"100%"}
                src={listCertifPopup[0]}
                fallback={defaultImage}
                alt="Certificate"
                preview={false}
                style={{ borderRadius: "12px" }}
                id="canvas-image"
              />
            )}
          </div>

          <Row
            style={{
              justifyContent: "center",
              flexWrap: "nowrap",
              gap: "4%",
              marginTop: "24px",
            }}
          >
            <Button
              id="close-modal-certificate"
              className="btn btn-sm btn-secondary"
              style={{
                width: "48%",
                borderRadius: "6px",
                border: "1px solid " + colorButtonLogOut,
                fontWeight: "500",
                fontSize: "14px",
                height: "40px",
              }}
              name="btn-close-modal-certificate"
              onClick={() => {
                setModalCertificate(false);
              }}
            >
              {t("main.popup.close")}
            </Button>
            <Button
              id="btn-download-certificates-user-profile"
              className="btn btn-sm btn-primary"
              icon={
                <DownloadOutlined
                  style={{
                    marginRight: 4,
                    width: "16px",
                    height: "15px",
                    fontSize: 16,
                    verticalAlign: "middle",
                  }}
                />
              }
              onClick={downloadImageCertif}
              style={{
                width: "48%",
                borderRadius: "6px",
                fontWeight: "500",
                height: "40px",
                fontSize: "14px",
                gap: "1px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              name="btn-download-certificates-user-profile"
            >
              <span style={{ marginTop: 2 }}>
                {t("feature.feature_profile.pop_up.download")}
              </span>
            </Button>
          </Row>
        </div>
      </Modal>

      <Modal
        className="modal-badges-mobile"
        open={isModalOpenBadges}
        maskClosable={false}
        transitionName="ant-fade"
        style={{ maxWidth: "585px", borderRadius: "16px", textAlign: "center" }}
        width={
          isMobileVersion
            ? isScallingVersion
              ? `${585 * 0.9}px`
              : "90%"
            : "90%"
        }
        keyboard
        centered
        footer={null}
        closeIcon={null}
        destroyOnClose={true}
      >
        <div style={{ padding: 20 }}>
          <Image
            width={200}
            height={150}
            preview={false}
            src={imgBadgesPopup}
            fallback={badges_example}
            style={{ objectFit: "contain", padding: 12 }}
          />

          <div
            style={{
              fontWeight: "500",
              fontSize: 14,
              color: colorTextTitleMobile,
              width: "80%",
              margin: "10px auto 16px auto",
            }}
          >
            {badgesNamePopup}
          </div>

          <div>
            <div
              style={{
                color: textDescProfile,
                fontSize: 12,
                fontWeight: "400",
                marginBottom: "4px",
              }}
            >
              {t("feature.feature_profile.sec_badges.earned_on_badges")}{" "}
              <span
                style={{
                  fontWeight: "500",
                  color: colorTextTitleMobile,
                  fontSize: 12,
                }}
              >
                {dateBadgesPopup}
              </span>
            </div>
            <div
              style={{
                color: textDescProfile,
                fontSize: 12,
                fontWeight: "400",
              }}
            >
              {t("feature.feature_profile.sec_badges.from_badges")}{" "}
              <span
                style={{
                  fontWeight: "500",
                  color: colorTextTitleMobile,
                  fontSize: 12,
                }}
              >
                {fromModuleBadgesPopup}
              </span>
            </div>
          </div>

          <Row
            style={{
              justifyContent: "center",
              flexWrap: "nowrap",
              gap: "20px",
              marginTop: "24px",
            }}
          >
            <Button
              id="close-modal-badges"
              className="btn btn-sm btn-primary"
              style={{
                width: "100%",
                borderRadius: "6px",
                fontWeight: "500",
                fontSize: "14px",
                height: "40px",
              }}
              name="btn-close-modal-badges"
              onClick={() => {
                setIsModalOpenBadges(false);
              }}
            >
              {t("main.popup.close")}
            </Button>
          </Row>
        </div>
      </Modal>

      <Modal
        className="modal-program-mobile"
        open={isModalProgram}
        maskClosable={false}
        transitionName="ant-fade"
        style={{ maxWidth: "585px", borderRadius: "16px" }}
        width={
          isMobileVersion
            ? isScallingVersion
              ? `${585 * 0.9}px`
              : "90%"
            : "90%"
        }
        keyboard
        centered
        footer={null}
        closeIcon={null}
        destroyOnClose={true}
      >
        <div style={{ padding: "20px 0 20px 18px" }}>
          <div
            style={{
              height: screens.xs ? "70vh" : isScallingVersion ? "45vh" : "70vh",
              overflowY: "auto",
              overflowX: "hidden",
              marginBottom: "20px",
              paddingRight: "18px",
            }}
          >
            <ModalDetailJourneyMobileContent
              loading={false}
              wraperStyle={null}
              rowImageStyle={{
                width: "100%",
                height: "100%",
                marginBottom: "16px",
              }}
              thumbnail={
                <Image
                  width={"100%"}
                  height={"100%"}
                  style={{
                    borderRadius: "8px",
                    objectFit: "fill",
                    height: "100%",
                  }}
                  src={ItemCompletedProgram.thumbnail}
                  preview={false}
                  alt="Journey Thumbnail Mobile Achievement"
                />
              }
              divRightStyle={{
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
              pProgramStyle={{
                fontSize: "10px",
                marginBottom: "0px",
                fontWeight: "400",
                color: colorTextDesc,
              }}
              titleJourneyDescStyle={{
                fontSize: "18px",
                fontWeight: "500",
                color: colorTextTitleMobile,
                marginRight: "8px",
                marginBottom: "3px",
              }}
              journeyName={ItemCompletedProgram.name}
              rowBottomFirstStyle={null}
              rowBottomSecondStyle={{
                display: "flex",
                alignItems: "center",
                marginBottom: "4px",
              }}
              pointImageWidth={16}
              totalPoint={
                ItemCompletedProgram.point !== null &&
                  ItemCompletedProgram.point !== undefined ? (
                  parseInt(ItemCompletedProgram.point) < 2 ? (
                    <span
                      style={{
                        color: textTitleProfile,
                        fontWeight: "500",
                        margin: "3px 5px 0 5px",
                        lineHeight: "normal",
                      }}
                    >
                      {ItemCompletedProgram.point}{" "}
                      {t(
                        "feature.feature_profile.sec_popup_completed_program.point_earned",
                      )}
                    </span>
                  ) : (
                    <span
                      style={{
                        color: textTitleProfile,
                        fontWeight: "500",
                        margin: "3px 5px 0 5px",
                        lineHeight: "normal",
                      }}
                    >
                      {ItemCompletedProgram.point}{" "}
                      {t(
                        "feature.feature_profile.sec_popup_completed_program.points_earned",
                      )}
                    </span>
                  )
                ) : (
                  <span
                    style={{
                      color: textTitleProfile,
                      fontWeight: "500",
                      margin: "0 5px",
                      lineHeight: "normal",
                    }}
                  >
                    -
                  </span>
                )
              }
              totalCourses={
                parseInt(ItemCompletedProgram.total_course) < 2 ? (
                  <span
                    style={{
                      color: textTitleProfile,
                      fontWeight: "500",
                      margin: "0 5px",
                      lineHeight: "normal",
                    }}
                  >
                    {ItemCompletedProgram.total_course}{" "}
                    {t(
                      "feature.feature_profile.sec_popup_completed_program.course",
                    )}
                  </span>
                ) : (
                  <span
                    style={{
                      color: textTitleProfile,
                      fontWeight: "500",
                      margin: "0 5px",
                      lineHeight: "normal",
                    }}
                  >
                    {ItemCompletedProgram.total_course}{" "}
                    {t(
                      "feature.feature_profile.sec_popup_completed_program.courses",
                    )}
                  </span>
                )
              }
              dividerStyle={{ margin: "20px 0" }}
              desc={
                ItemCompletedProgram.description != "" ? (
                  <div
                    style={{
                      textAlign: "left",
                      lineHeight: "20px",
                      whiteSpace: "pre-wrap",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: colorTextDesc,
                      marginTop: "16px",
                    }}
                  >
                    {ItemCompletedProgram.description}
                  </div>
                ) : (
                  ""
                )
              }
              overDue={""}
            />
          </div>
          <div style={{ paddingRight: "18px" }}>
            <Button
              className="btn btn-primary"
              block
              style={{
                fontSize: "14px",
                fontWeight: "500",
                borderRadius: "6px",
                height: "40px",
              }}
              id="btn-close-modal-journey"
              onClick={() => setIsModalProgram(false)}
            >
              {t("main.popup.close")}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal-additional-learning-mobile"
        open={isModalAdditionalLearning}
        maskClosable={false}
        transitionName="ant-fade"
        style={{ maxWidth: "585px", borderRadius: "16px" }}
        width={
          isMobileVersion
            ? isScallingVersion
              ? `${585 * 0.9}px`
              : "90%"
            : "90%"
        }
        keyboard
        centered
        footer={null}
        closeIcon={null}
        destroyOnClose={true}
      >
        <div style={{ padding: "20px 0 20px 18px" }}>
          <div
            style={{
              height: screens.xs ? "70vh" : isScallingVersion ? "45vh" : "70vh",
              overflowY: "auto",
              overflowX: "hidden",
              marginBottom: "20px",
              paddingRight: "18px",
            }}
          >
            <ModalContentAdditional
              loading={false}
              wraperStyle={null}
              rowImageStyle={{
                width: "100%",
                height: "100%",
                marginBottom: "16px",
              }}
              thumbnail={
                <Image
                  width={"100%"}
                  height={"100%"}
                  style={{
                    borderRadius: "8px",
                    objectFit: "fill",
                    height: "100%",
                  }}
                  src={
                    "data:image/png;base64," +
                    itemAdditionalLearning.thumbnail_base64
                  }
                  preview={false}
                  alt="Additional Thumbnail Mobile Achievement"
                />
              }
              divRightStyle={{
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
              pModuleStyle={{
                fontSize: "10px",
                marginBottom: "0px",
                fontWeight: "400",
                color: colorTextDesc,
              }}
              titleModuleDescStyle={{
                fontSize: "18px",
                fontWeight: "500",
                color: colorTextTitleMobile,
                marginRight: "8px",
                marginBottom: "3px",
              }}
              moduleName={itemAdditionalLearning?.name}
              rowBottomFirstStyle={{
                display: "flex",
                alignItems: "center",
                marginBottom: "4px",
                width: "fit-content",
                maxWidth: "fit-content",
                fontSize: "12px",
              }}
              rowBottomSecondStyle={{
                display: "flex",
                alignItems: "center",
                marginBottom: "4px",
                flex: 1,
                flexWrap: "nowrap",
              }}
              pointImageWidth={16}
              totalPoint={
                itemAdditionalLearning?.point !== null &&
                  itemAdditionalLearning?.point !== undefined ? (
                  parseInt(itemAdditionalLearning?.point) < 2 ? (
                    <span
                      style={{
                        color: textTitleProfile,
                        fontWeight: "500",
                        margin: "3px 5px 0 5px",
                        lineHeight: "normal",
                        fontSize: "12px",
                      }}
                    >
                      {itemAdditionalLearning?.point}{" "}
                      {t("feature.feature_tm.point_earned")}
                    </span>
                  ) : (
                    <span
                      style={{
                        color: textTitleProfile,
                        fontWeight: "500",
                        margin: "3px 5px 0 5px",
                        lineHeight: "normal",
                        fontSize: "12px",
                      }}
                    >
                      {itemAdditionalLearning?.point}{" "}
                      {t("feature.feature_tm.points_earned")}
                    </span>
                  )
                ) : (
                  <span
                    style={{
                      color: textTitleProfile,
                      fontWeight: "500",
                      margin: "0 5px",
                      lineHeight: "normal",
                    }}
                  >
                    -
                  </span>
                )
              }
              moduleType={itemAdditionalLearning?.module_type}
              dividerStyle={{ margin: "20px 0" }}
              desc={
                itemAdditionalLearning?.description != "" ? (
                  <div
                    style={{
                      textAlign: "left",
                      lineHeight: "20px",
                      whiteSpace: "pre-wrap",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: colorTextDesc,
                      marginTop: "16px",
                    }}
                  >
                    {itemAdditionalLearning?.description}
                  </div>
                ) : (
                  ""
                )
              }
              overDue={""}
            />
          </div>
          <div style={{ paddingRight: "18px" }}>
            <Button
              className="btn btn-primary"
              block
              style={{
                fontSize: "14px",
                fontWeight: "500",
                borderRadius: "6px",
                height: "40px",
              }}
              id="btn-close-modal-module"
              onClick={() => setIsModalAdditionalLearning(false)}
            >
              {t("main.popup.close")}
            </Button>
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default SidebarMobile;
